
import { QualityControlAssignmentDto, CreateQualityControlAssignmentDto, UpdateQualityControlAssignmentDto } from '@services/dtos'
import { baseCrudReducer } from './baseCrudReducer'
import { qualityControlAssignmentService, QualityControlAssignmentsFilters } from '@services/QualityControlAssignmentService'

const { reducer, actions, thunks } = baseCrudReducer<
  QualityControlAssignmentDto,
  CreateQualityControlAssignmentDto,
  UpdateQualityControlAssignmentDto,
  QualityControlAssignmentsFilters
>('qualityControlAssignment', qualityControlAssignmentService)

export default reducer

export const { setFilters: setQualityControlAssignmentFilters } = actions

export const {
  getAll: getQualityControlAssignments,
  create: createQualityControlAssignment,
  update: updateQualityControlAssignment,
  remove: removeQualityControlAssignment,
} = thunks
